(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup-smf"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var SMF_FORM_ID = '5020-records-shopify-store-signupform-2026';
    var SMF_ENDPOINT = 'https://subs.sonymusicfans.com/submit';
    var SMF_TIMEOUT_MS = 8000;

    // Only these fields are sent to SMF. The Shopify form also contains
    // form_type, utf8, contact[...] and captcha fields — those must NOT reach SMF.
    var SMF_FIELDS = [
      'js_url',
      'ae_segment_id',
      'ae_brand_id',
      'form',
      'field_email_address',
      'field_first_name',
      'field_last_name',
      'field_country_region',
      'triggered_sends[]',
      'virtual_participants[0]'
    ];

    function isDebug(form) {
      var wrap = form.closest('.smf-signup');
      return (wrap && wrap.dataset.smfDebug === 'true') || /[?&]smf_debug=1/.test(window.location.search);
    }

    function log(form) {
      if (!isDebug(form)) return;
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift('[SMF signup]');
      console.log.apply(console, args);
    }

    // Mirrors jQuery .serialize(): DOM order, skips disabled + unchecked
    // checkboxes/radios, url-encodes with "+" for spaces.
    function buildSmfPayload(form) {
      var params = new URLSearchParams();
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || el.disabled) return;
        if (SMF_FIELDS.indexOf(el.name) === -1) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        params.append(el.name, el.value);
      });
      return params;
    }

    // Copies the visible SMF fields into the hidden Shopify contact[...] fields.
    function syncShopifyFields(form) {
      var email = form.querySelector('[name="field_email_address"]').value.trim();
      var first = form.querySelector('[name="field_first_name"]').value.trim();
      var last = form.querySelector('[name="field_last_name"]').value.trim();
      var country = form.querySelector('[name="field_country_region"]').value;

      form.querySelector('[data-smf-shopify="email"]').value = email;
      form.querySelector('[data-smf-shopify="first_name"]').value = first;
      form.querySelector('[data-smf-shopify="last_name"]').value = last;
      form.querySelector('[data-smf-shopify="tags"]').value = country ? 'newsletter, country:' + country : 'newsletter';
    }

    function postToSmf(form, payload) {
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = controller
        ? setTimeout(function () {
            controller.abort();
          }, SMF_TIMEOUT_MS)
        : null;

      return fetch(SMF_ENDPOINT, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit', // matches xhrFields.withCredentials: false
        keepalive: true, // lets the request finish if the page navigates
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01'
        },
        body: payload, // URLSearchParams => application/x-www-form-urlencoded;charset=UTF-8
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          log(form, 'SMF response status:', response.status);
          return response.text().then(function (text) {
            log(form, 'SMF response body:', text);
            return response.ok;
          });
        })
        .catch(function (error) {
          // Never block the Shopify signup because SMF failed.
          console.error('[SMF signup] SMF submission failed:', error);
          return false;
        })
        .finally(function () {
          if (timer) clearTimeout(timer);
        });
    }

    // Parity with client script: keep triggered_sends in sync with the opt-in.
    // The opt-in is hidden, so this only runs if it is ever made visible.
    document.addEventListener('change', function (event) {
      var el = event.target;
      if (!el.classList || !el.classList.contains('mailing-list-id')) return;
      var ts = document.getElementById('ts-for-' + el.id);
      if (ts) ts.checked = el.checked;
    });

    // Capture phase on document runs BEFORE Shopify's CAPTCHA submit handler.
    // Pass 1: block the submit (and Shopify's handler), POST to SMF.
    // Pass 2: re-fire a real submit event via requestSubmit() so Shopify's
    // CAPTCHA script runs, injects its token, and submits the customer form.
    // (form.submit() skips submit handlers -> "Invalid CAPTCHA token".)
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        // id starts with a digit, so match on .id instead of a CSS #selector.
        if (!form || form.id !== SMF_FORM_ID) return;

        // Pass 2: SMF already sent — let Shopify (incl. CAPTCHA) handle it.
        if (form.dataset.smfSent === 'true') {
          log(form, 'Pass 2: handing off to Shopify customer form + CAPTCHA');
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if (form.dataset.smfSubmitting === 'true') return;
        if (!form.reportValidity()) return;

        form.dataset.smfSubmitting = 'true';
        var button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;

        syncShopifyFields(form);
        var payload = buildSmfPayload(form);
        log(form, 'SMF payload:', payload.toString());

        var handOff = function () {
          form.dataset.smfSent = 'true';
          form.dataset.smfSubmitting = 'false';
          if (button) button.disabled = false;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else if (button) {
            button.click();
          } else {
            HTMLFormElement.prototype.submit.call(form);
          }
        };

        // Don't send real data to SMF while editing in the theme editor.
        if (window.Shopify && window.Shopify.designMode) {
          log(form, 'Theme editor detected - SMF POST skipped');
          handOff();
          return;
        }

        postToSmf(form, payload).then(handOff);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
